import styled from "styled-components";

export const AssetStyledWrapperStyled = styled.div<{
  isGridExpanded?: boolean;
}>`
  padding: ${({ isGridExpanded }): string =>
    isGridExpanded ? "5px 20px 5px" : "22px 25px"};
`;
